module.exports = {
    rating: {
        en: "Rating",
        fi: "Arvostelu"
    },
    postedOn: {
        en: "posted on",
        fi: "Julkaistu"
    }
};